var Block_Garanties = {
    init:function(){
        $(window).resize(function(){
            Block_Garanties.resize();
        });
        Block_Garanties.resize();
    },
    resize:function(){
        $(".block-garanties").each(function(){
            var _h_header = 0;
            $(this).find(".garantie-header").css({height:"auto"});
            $(this).find(".garantie").each(function(){
                _h_header = Math.max(_h_header, $(this).find(".garantie-header").outerHeight());
            });
            $(this).find(".garantie-header").css({height:_h_header});


            var _h_content = 0;
            $(this).find(".garantie-content").css({height:"auto"});
            $(this).find(".garantie").each(function(){
                _h_content = Math.max(_h_content, $(this).find(".garantie-content").outerHeight());
            });
            $(this).find(".garantie-content").css({height:_h_content});
        })
    }
}

$(window).load(function(){
    if($(".block-garanties").length){
        Block_Garanties.init();
    }
})